import React, { useEffect, useState } from "react";
import QRCode from 'qrcode';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from 'moment';
import { METER_ICON, REPORT_ICON, QR_ICON, LOCATION } from "../../assets/constants/Icons";
import Spinner from 'components/Spinner';
import { getPartnerTotalCall, getPartnerById } from "lib/axiosUtils";
import { WEB_APP_URL, QR_FONT_COLOR, QR_BACKGROUND_COLOR, TYPE_FAIL, INTERVAL, TJP_BRAND_COLOR } from "../../assets/constants/Constants";
import ShowToast from 'components/ShowToast';
import LocationCapture from "components/TrainingPartner/LocationCapture";

const PartnerDashboardPage = (props) => {
    const [totalPartnerData, setTotalPartnerData] = useState({});
    const [loadingComplete, setLoadingComplete] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const userDetail = JSON.parse(localStorage.getItem("userData"));
    const [partnerId, setPartnerId] = useState(userDetail && userDetail.partner_id ? userDetail.partner_id : props && props.partnerId ? props.partnerId : props && props.location && props.location.state ? props.location.state : "");
    const [downloadQRLoading, setDownloadQRLoading] = useState(false);    
    const [captureLocationModal, setCaptureLocationModal] = useState(false);

    useEffect(() => {
        const fetchPartnerData = async () => {
            if (partnerId) {
                try {
                    const response = await getPartnerById({}, {}, partnerId);
                    if (response && response.data && response.data.result) {
                        const partnerData = response.data.result;

                        // Check if the partner's `is_approved` status is "pending"
                        if (partnerData.is_approved === "pending" || partnerData.is_approved === "rejected") {
                            ShowToast(
                                "Your profile is under review. Please wait or contact the admin.",
                                TYPE_FAIL,
                                INTERVAL,
                                "",
                                ""
                            );
                            setTimeout(() => {
                                window.localStorage.clear();
                                window.location.href = "/login";
                            }, 7000);
                            return;
                        }
                    }
                } catch (error) {
                    console.log("Error while fetching partner data", error);
                }
            }
        };

        fetchPartnerData();
    }, [partnerId]);

    useEffect(() => {
        const fetchPartnerTotal = async () => {
            try {
                const data = await getPartnerTotalCall({},{},partnerId);
                setTotalPartnerData(data.data.result);
                setLoadingComplete(true);
            }
            catch (error) {
                console.log("Error while fetching data", error);
                setLoadingComplete(true);
            }
        }
        fetchPartnerTotal();
    }, [partnerId])

    useEffect(() => {
        if (props && props.partnerId) {
            setPartnerId(props.partnerId);
            setLoadingComplete(false);
        }
    }, [props])

    const exportToExcel = async () => {
        setDownloadLoading(true);
        const object = {
            ...totalPartnerData
        }
        const data = [object]
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sheet 1");
        const columns = [
            { header: "Name of TP Company", key: "partnerName" },
            { header: "Name of TP Unit", key: "trainingPartner" },
            { header: "City", key: "city" },
        ];

        data.forEach((row) => {
            const dataRow = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    dataRow.push("Partner Details");
                }
                else {
                    dataRow.push("");
                }
            });
            worksheet.addRow(dataRow).font = { bold: true };
        })

        const mainHeaderRow = worksheet.addRow(columns.map((column) => column.header));
        mainHeaderRow.font = { bold: true };
        mainHeaderRow.alignment = { vertical: "middle", horizontal: "center" };

        data.forEach((row) => {
            const dataRow = [];
            columns.forEach((column) => {
                dataRow.push(row[column.key]);
            });
            worksheet.addRow(dataRow).alignment = { vertical: "middle", horizontal: "center" };
        })
        worksheet.addRow("");
        worksheet.addRow("");
        data.forEach((row) => {
            const dataRow = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    dataRow.push("TOTALS");
                }
                else {
                    dataRow.push("");
                }
            });
            worksheet.addRow(dataRow).font = { bold: true };
        })

        const thsccolumns = [
            { header: "Total Project", key: "totalProject" },
            { header: "Total Active Project", key: "activeProject" },
            { header: "Total Project Complete", key: "completeProject" },
            { header: "Total Candidate Expected", key: "candidateExpected" },
            { header: "Total Candidate Selected", key: "totalCandidateAssigned" },
            { header: "Total Candidate Deployed", key: "candidatesDelivered" },
            { header: "Total Candidate Drop Out", key: "candidateDropout" },
        ]
        const thscmainHeaderRow = worksheet.addRow(thsccolumns.map((column) => column.header));
        thscmainHeaderRow.font = { bold: true };
        thscmainHeaderRow.alignment = { vertical: "middle", horizontal: "center" };
        data.forEach((row) => {
            const dataRow = [];
            thsccolumns.forEach((column) => {
                dataRow.push(row[column.key]);
            });
            worksheet.addRow(dataRow).alignment = { vertical: "middle", horizontal: "center" };;
        })
        worksheet.addRow("");
        worksheet.addRow("");
        const headerCell = worksheet.getCell(1, 1);
        headerCell.alignment = { vertical: "middle", horizontal: "center" };
        headerCell.font = { bold: true };
        headerCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ff285c60" }
        };
        const headerCellTHSC = worksheet.getCell(6, 1);
        headerCellTHSC.alignment = { vertical: "middle", horizontal: "center" };
        headerCellTHSC.font = { bold: true };
        headerCellTHSC.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "ff4aafb2" }
        };

        worksheet.columns.forEach(column => {
            column.eachCell(cell => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };
            });
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const todayDate = moment(Date.now()).format("DD_MM_YYYY-HH_mm");
        let fileName = `${totalPartnerData.trainingPartner} ${todayDate}.xlsx`;
        saveAs(new Blob([buffer]), fileName);
        setDownloadLoading(false);
    }

    const handleGenerateQR = async () => {
        setDownloadQRLoading(true);

        if (!totalPartnerData.trainingPartner || !totalPartnerData.city) {
            ShowToast("Missing required data for QR code generation", TYPE_FAIL, INTERVAL, props, "");
            setDownloadQRLoading(false);
            return;
        }

        const tpInfo = {
            tpName: totalPartnerData.trainingPartner,
            city: totalPartnerData.city
        };

        const qrData = `${WEB_APP_URL}/qr-attendance/${partnerId}`;
        const qrCanvas = document.createElement('canvas');

        await QRCode.toCanvas(qrCanvas, qrData, {
            errorCorrectionLevel: 'H',
            width: 290,
            margin: 2,
        });

        const tempCtx = qrCanvas.getContext('2d');
        tempCtx.font = '16px Arial';

        const headingText = `${tpInfo.tpName}, ${tpInfo.city}`;
        const logoSize = 50;
        const padding = 10;
        const lineHeight = 20;
        const headerPaddingTop = 15;
        const footerText = `Scan to mark your attendance`;
        const footerMarginBottom = 7;
        const qrBorderSize = 2; // 1px border + 1px space

        // Wrap header text
        const textAreaWidth = qrCanvas.width - logoSize - 30;
        const wrappedHeaderLines = wrapText(headingText, textAreaWidth, tempCtx);
        const textBlockHeight = wrappedHeaderLines.length * lineHeight;

        const headerBlockHeight = Math.max(textBlockHeight, logoSize) + headerPaddingTop;
        const footerHeight = lineHeight;

        // Final canvas size
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = qrCanvas.width + 13;
        finalCanvas.height =
            headerBlockHeight + qrCanvas.height + footerHeight + padding * 2 + footerMarginBottom + qrBorderSize * 2;

        const ctx = finalCanvas.getContext('2d');

        // Background
        ctx.fillStyle = QR_BACKGROUND_COLOR;
        ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height);

        const logoImage = new Image();
        logoImage.crossOrigin = "anonymous";

        logoImage.onload = () => {
            // Header text vertically aligned with logo
            const textStartY = headerPaddingTop + (logoSize - textBlockHeight) / 2;

            ctx.fillStyle = QR_FONT_COLOR;
            ctx.font = '16px Arial';
            ctx.textAlign = 'left';
            ctx.textBaseline = 'top';

            wrappedHeaderLines.forEach((line, i) => {
                ctx.fillText(line, 10, textStartY + i * lineHeight);
            });

            // Logo top right
            const logoX = finalCanvas.width - logoSize - 10;
            const logoY = headerPaddingTop;
            ctx.save();
            ctx.beginPath();
            ctx.arc(logoX + logoSize / 2, logoY + logoSize / 2, logoSize / 2, 0, Math.PI * 2);
            ctx.closePath();
            ctx.clip();
            ctx.drawImage(logoImage, logoX, logoY, logoSize, logoSize);
            ctx.restore();

            // QR position
            const qrX = 5 + qrBorderSize;
            const qrY = headerBlockHeight + padding;

            // Draw QR border
            ctx.fillStyle = TJP_BRAND_COLOR;
            ctx.fillRect(qrX - qrBorderSize, qrY - qrBorderSize, qrCanvas.width + qrBorderSize * 2, qrCanvas.height + qrBorderSize * 2);

            // Draw QR image inside border
            ctx.drawImage(qrCanvas, qrX, qrY);

            // Footer text above bottom
            ctx.fillStyle = QR_FONT_COLOR;
            ctx.font = '14px Arial';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            ctx.fillText(
                footerText,
                finalCanvas.width / 2,
                finalCanvas.height - footerMarginBottom - 5
            );

            // Download image
            const image = finalCanvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = image;
            link.download = `TP_${tpInfo.tpName.replace(/\s+/g, '_')}_QR.png`;
            link.click();

            setDownloadQRLoading(false);
        };

        logoImage.src = "/images/tjp-logo.png";
    };

    function wrapText(text, maxWidth, context) {
        const words = text.split(' ');
        let lines = [];
        let line = "";

        for (let word of words) {
            const testLine = line + word + " ";
            const metrics = context.measureText(testLine);
            const testWidth = metrics.width;

            if (testWidth > maxWidth && line !== "") {
                lines.push(line.trim());
                line = word + " ";
            } else {
                line = testLine;
            }
        }

        if (line) lines.push(line.trim());
        return lines;
    }

    const handleCaptureLocation = () => {
        setCaptureLocationModal(true);
    }

    const handlecloseModal = () => {
        setCaptureLocationModal(false);
    }

    return (<>
        {
            loadingComplete === false ? (
                <Spinner />
            ) : (
            <>
                <div className="admin-dashboard-outer-wrapper employer-dashboard-outer-wrapper">
                    <div className="admin-dasboard-icon">
                        <h4><i className={`${METER_ICON} list-table-icon`}></i>{totalPartnerData.trainingPartner} Dashboard</h4>
                        <div>
                            {
                                downloadLoading === true ? (
                                    <div className="spinner-loader"></div>
                                ) : (
                                    <button className="brand-button width-auto partner-dashboard-buttons ml-2" onClick={exportToExcel}><i className={`${REPORT_ICON}`}></i>Download Report</button>
                                )
                            }
                            {
                                <button
                                    type="button"
                                    className="brand-button width-auto ml-2 partner-dashboard-buttons"
                                    onClick={handleCaptureLocation}
                                >
                                    <i className={`${LOCATION}`}></i>
                                    Capture Location
                                </button>
                            }
                            {
                                downloadQRLoading === true ? (
                                    <div className="spinner-loader ml-2"></div>
                                ) : (
                                    <button className="brand-button width-auto ml-2 partner-dashboard-buttons" onClick={handleGenerateQR}><i className={`${QR_ICON}`}></i>Download QR Code</button>
                                )
                            }
                        </div>
                    </div>
                    <div className="admin-dashboard-outer-div employer-dashboard-outer-div">
                        <div className="admin-dashboad-total-div employer-dashboad-total-div">
                            <div className="total-title-div total-div-background-color">
                                <div className="total-title-header-div">
                                    <p>Partner Details</p>
                                </div>
                            </div>
                            <div className="total-value-outer-div employer-total-value-outer-div">
                                <div className="employer-total-inner-div">
                                    <p className="employer-total-inner-header">Name of TP Company : </p>
                                    <p className="employer-total-value">{totalPartnerData.partnerName}</p>
                                </div>
                                <div className="employer-total-inner-div">
                                    <p className="employer-total-inner-header">Name of TP Unit : </p>
                                    <p className="employer-total-value">{totalPartnerData.trainingPartner}</p>
                                </div>
                                <div className="employer-total-inner-div">
                                    <p className="employer-total-inner-header">City : </p>
                                    <p className="employer-total-value">{totalPartnerData.city}</p>
                                </div>
                            </div>
                        </div>
                        <div className="seprator-line"></div>
                        <div className="admin-dashboad-total-div employer-dashboad-total-div">
                            <div className="total-title-div">
                                <div className="total-title-header-div">
                                    <p>Total</p>
                                </div>
                            </div>
                            <div className="total-value-outer-div">
                                <div className="total-value-inner-div">
                                    <div className="total-value-div">
                                        <p>Total Projects</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.totalProject}
                                        </div>
                                    </div>
                                    <div className="total-value-div">
                                        <p>Candidates Expected</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.candidateExpected}
                                        </div>
                                    </div>
                                    <div className="total-value-div">
                                        <p>Training Period Drop Out</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.candidateDropout}
                                        </div>
                                    </div>
                                </div>
                                <div className="total-value-inner-div">
                                    <div className="total-value-div">
                                        <p>Active Projects</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.activeProject}
                                        </div>
                                    </div>
                                    <div className="total-value-div">
                                        <p>Candidates Selected</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.totalCandidateAssigned}
                                        </div>
                                    </div>
                                    <div className="total-value-div"></div>
                                </div>
                                <div className="total-value-inner-div">
                                    <div className="total-value-div">
                                        <p>Complete Projects</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.completeProject}
                                        </div>
                                    </div>
                                    <div className="total-value-div">
                                        <p>Candidates Deployed</p>
                                        <div className="total-value-box">
                                            {totalPartnerData.candidatesDelivered}
                                        </div>
                                    </div>
                                    <div className="total-value-div"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    captureLocationModal && (
                        <LocationCapture isOpen={captureLocationModal} closeModel={handlecloseModal} partnerId={partnerId} />
                    )
                }
            </>
            )
        }
    </>);
}
export default PartnerDashboardPage;